<template>
  <div class="uni-progress">
    <div class="progress-persent" :style="{ left: percentage }" v-if="isHide">
      {{ percentage }}
    </div>
    <div class="progress" :style="{ width: percentage }"></div>
  </div>
</template>

<script>
export default {
  name: "ComponentProgress",
  props: {
    percentage: {
      type: String,
      default: "0%",
    },
    isHide: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-progress {
  position: relative;
  width: 100%;
  height: 12px;
  border-radius: 7px;
  background: #d9dbdc;

  .progress {
    width: 0;
    height: 100%;
    border-radius: 7px;
    // @include themeIcon('progress');
    @include linearGradientOne("progress-start", "progress-end");
    // @include bgColor('primary');
    background-size: auto 112% !important;
    transition: all 0.6s ease-in-out;
  }

  .progress-persent {
    position: absolute;
    top: -50px;
    left: 0;
    transform: translate(-50%);
    width: 40px;
    height: 50px;
    @include themeIcon("pro_arrow");
    background-size: 100% auto;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 40px;
    transition: all 0.6s ease-in-out;
  }
}
</style>
